import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';
import { AUTH_LEVELS } from '../auth/Authorized';
import { updateCurrentPath, getSearchParams } from '../../utils/url';
import { Page, Row, Fill } from '../util/Page';
import DeploymentStats from './DeploymentStats';
import DeploymentList from './DeploymentList';
import { DeploymentsLoader, HeartbeatsLoader } from '../loaders/deployments';
import AlertsLoader from '../loaders/AlertsLoader';
import BuildingsLoader from '../loaders/BuildingsLoader';
import ActiveAlerts from '../ingestQa/ActiveAlerts';

const DeploymentsPage = ({ showAlerts }) => {
  const location = useLocation();
  const params = getSearchParams(location.search);
  const { site } = params;
  const navigate = useNavigate();
  return (
    <div style={{ display: 'grid' }}>
      <Page name="deployment-stats">
        <DeploymentsLoader />
        <HeartbeatsLoader />
        <BuildingsLoader />

        <Row>
          <Typography variant="h6">Deployments</Typography>
          <Fill />
          <DeploymentStats />
        </Row>
        {showAlerts ? (
          <Row>
            <AlertsLoader />
            <ActiveAlerts
              hiddenWhenEmpty
              filter={({ key }) => key.indexOf('site-heartbeat') === 0}
            />
          </Row>
        ) : null}
      </Page>
      <DeploymentList selected={site} onSelect={(s) => updateCurrentPath(navigate, { site: s })} />
    </div>
  );
};

export default connect(({ user: { userAuthLevel } }) => ({
  showAlerts: userAuthLevel <= AUTH_LEVELS.ORG_ADMIN,
}))(DeploymentsPage);
